'use strict';

define(['cookie', 'columboConstants', '$location', 'lodash', 'siteObj', 'uaParser', '$window'], function (cookie, columboConstants, $location, _, siteObj, uaParser, $window) {
  var Metrics = function Metrics() {
    var module = {};
    var sessionId = cookie.get(columboConstants.chaseSessionKey);
    var userId = cookie.get(columboConstants.chaseUserKey);
    var _uaParser = new uaParser();
    var uaParserResult = _uaParser.getResult();

    // https://github.com/faisalman/ua-parser-js/issues/182
    // https://github.com/faisalman/ua-parser-js/issues/224
    var isPC = function isPC(operatingSystem) {
      var hashTable = {
        'aix': true,
        'amiga os': true,
        'android': false,
        'arch': true,
        'bada': false,
        'beos': true,
        'blackberry': false,
        'centos': true,
        'chromium os': true,
        'contiki': true,
        'fedora': true,
        'firefox os': false,
        'freebsd': true,
        'debian': true,
        'dragonfly': true,
        'gentoo': true,
        'gnu': true,
        'haiku': true,
        'hurd': true,
        'ios': false,
        'joli': true,
        'linpus': true,
        'mac os': true,
        'mageia': true,
        'mandriva': true,
        'meego': false,
        'minix': true,
        'mint': true,
        'morph os': true,
        'netbsd': true,
        'nintendo': false,
        'openbsd': true,
        'openvms': true,
        'os/2': true,
        'palm': false,
        'pc-bsd': true,
        'pclinuxos': true,
        'playstation': false,
        'qnx': true,
        'redhat': true,
        'rim tablet os': false,
        'risc os': true,
        'sailfish': false,
        'series40': false,
        'slackware': true,
        'solaris': true,
        'suse': true,
        'symbian': false,
        'tizen': true,
        'ubuntu': true,
        'unix': true,
        'vectorlinux': true,
        'webos': false,
        'windows': true,
        'windows phone': false,
        'windows mobile': false,
        'zenwalk': true
      };
      return hashTable[operatingSystem.toLowerCase()] ? hashTable[operatingSystem.toLowerCase()] : false;
    };

    // sections to include in the metrics data
    // optionally pass in an element if collecting element-specific metrics
    var _getMetrics = function _getMetrics(sections) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var eventData = {};
      if (args) {
        eventData.args = args;
      }
      sections.forEach(function (section) {
        switch (section) {
          case 'ux':
            eventData.server = {
              ip: '',
              hostname: '',
              elysium_version: module.getSiteObjItem('version'),
              columbo_version: columboConstants.columboVersion
            };

            eventData.request = {
              url: $location.toString(),
              client_timestamp: Math.round(new Date().getTime() / 1000)
            };

            eventData.property = {
              site_id: module.getSiteObjItem('siteID'),
              channel: module.getSiteObjItem('siteCode'),
              shipping_country_code: module.getSiteObjItem('shippingCountry'),
              subsite: module.getSiteObjItem('subsiteCode'),
              is_mobile_version: module.getSiteObjItem('siteIsMobile'),
              locale: module.getSiteObjItem('siteDefaultLocale')
            };

            eventData.device = {
              cookie: userId,
              sess_cookie: sessionId,
              type: {
                family: uaParserResult.device.type,
                brand: uaParserResult.device.vendor,
                model: uaParserResult.device.model,
                is_mobile: uaParserResult.device.type === 'mobile',
                is_tablet: uaParserResult.device.type === 'tablet',
                is_pc: uaParserResult.device.type !== 'mobile' && uaParserResult.device.type !== 'tablet' ? isPC(uaParserResult.os.name) : ''
              },
              screen: {
                width: $window.screen.width,
                height: $window.screen.height,
                devicePixelRatio: $window.devicePixelRatio ? $window.devicePixelRatio : ''
              },
              browser: {
                family: uaParserResult.browser.name,
                version: uaParserResult.browser.version,
                major_version: uaParserResult.browser.major
              },
              ip: {
                country: module.getSiteObjItem('customerLocation')
              }
            };

            eventData.experiments = module.getSiteObjItem('experiments');
            eventData.errors = [];
            eventData.event = args;
            eventData.attributes = [];
            eventData.nonce = module.getSiteObjItem('nonce');
            break;
          case 'meta':
            eventData.meta = module.getMetaData();
            break;
          case 'performance':
            eventData.performance = module.getPerformanceStats();
            break;
          case 'experiments':
            eventData.experiments = module.getExperiments();
            break;
          case 'widget':
            var element = void 0;
            if (args[0] && args[0].nodeType === 1) {
              element = args[0];
            }
            if (args[0] && args[0].srcElement) {
              element = args[0].srcElement;
            }
            eventData.widget = module.getWidgetData(element);
            break;
          case 'products':
            eventData.products = module.getProducts();
            break;
          case 'basket':
            eventData.basket = module.getBasket(args);
            break;
          default:
            eventData[section] = {
              message: 'this metric is not defined.'
            };
        }
      });
      return eventData;
    };

    var _findWidgetElement = function _findWidgetElement(element) {
      var elementToSearch = element;
      while (elementToSearch !== document.body && elementToSearch.parentNode) {
        if (elementToSearch.getAttribute('data-widget-id')) {
          return elementToSearch;
        }
        elementToSearch = elementToSearch.parentNode;
      }
      return null;
    };

    var _getWidgetData = function _getWidgetData(element) {
      var widget = {};
      if (element) {
        var widgetElement = _findWidgetElement(element);
        if (widgetElement) {
          widget.id = widgetElement.getAttribute('data-widget-id');
          widget.type = widgetElement.getAttribute('data-block-type');
          widget.name = widgetElement.getAttribute('data-block-name');
          widget.link = _findHref(widgetElement);
        }
      }
      return widget;
    };

    var _findHref = function _findHref(element) {
      if (element.href) {
        return element.href;
      }
      var link = element.querySelector('[href]');
      if (link && link.href) {
        return link.href;
      }
      return null;
    };

    var _getMetaData = function _getMetaData() {
      if (module && !module.meta) {
        module.meta = {
          sessionId: sessionId,
          userId: userId,
          URL: $location.toString(),
          siteDefaultLocale: module.getSiteObjItem('siteDefaultLocale'),
          countryCode: module.getSiteObjItem('countryCode'),
          currency: module.getSiteObjItem('currencyType'),
          customerLocale: module.getSiteObjItem('customerLocale'),
          customerLocation: module.getSiteObjItem('customerLocation'),
          nonce: module.getSiteObjItem('nonce'),
          shippingCountry: module.getSiteObjItem('shippingCountry'),
          elysiumVersion: module.getSiteObjItem('version'),
          serverIP: module.getSiteObjItem('serverIP'),
          siteCode: module.getSiteObjItem('siteCode'),
          subsiteCode: module.getSiteObjItem('subsiteCode'),
          siteID: module.getSiteObjItem('siteID'),
          productID: module.getSiteObjItem('productID')
        };
      }
      return module.meta;
    };

    var _getSiteObjItem = function _getSiteObjItem(key) {
      return _.get(siteObj, key) ? siteObj[key] : '';
    };

    var _getExperiments = function _getExperiments() {
      if (!module.experiments) {
        module.experiments = _getSiteObjItem('experiments');
      }
      return module.experiments;
    };

    var _getPerformanceStats = function _getPerformanceStats(forceCalculate) {
      // use forceCalculate to ignore stored results
      if (!module.performanceStats || forceCalculate) {
        var timing = void 0;
        var stats = {};

        // Check for timing support
        if (module.isTimingEnabled) {
          timing = module.timingAPI;
          var startTime = timing.navigationStart;
          // if this function is called by an onLoad handler, loadEventEnd will be 0 so use loadEventStart instead
          var endTime = timing.loadEventStart;
          if (timing.loadEventEnd > 0) {
            endTime = timing.loadEventEnd;
          }
          var totalTime = endTime - startTime;

          // Gather stats
          stats = {
            // Total load time from start until end
            navigationTime: totalTime,

            // Total network time from start to fetch
            redirectTime: timing.redirectEnd - timing.redirectStart,

            // Total time checking/retrieving from cache
            cacheTime: timing.domainLookupStart - timing.fetchStart,

            // Total DNS query time
            dnsTime: timing.domainLookupEnd - timing.domainLookupStart,

            // Total time spent connecting, SSL handshakes etc
            connectionTime: timing.connectEnd - timing.connectStart,

            // Total time from connection until last byte
            backendLoadTime: timing.responseEnd - timing.requestStart,

            // Total time from start to DOM interative
            domInteractiveTime: timing.domInteractive - startTime,

            // Total time receiving/parsing the DOM
            domParsingTime: timing.domInteractive - timing.domLoading,

            // Total time spend constructing the DOM tree
            domReadyTime: timing.domComplete - timing.domInteractive,

            // Total time constructing the DOM until load event fires
            frontendLoadTime: endTime - timing.domInteractive
          };

          if (endTime !== timing.loadEventStart) {
            // Total time running the load event listeners
            stats.loadEventTime = endTime - timing.loadEventStart;
          }

          // IE
          if (typeof timing.msFirstPaint === 'number') {
            timing.firstPaint = timing.msFirstPaint;
          }

          // Add first paint to stats
          if (timing.firstPaint) {
            stats.firstPaintTime = Math.round(timing.firstPaint - startTime);
          }

          // Chrome
          if ($window.PerformancePaintTiming) {
            stats.firstPaintTime = Math.round(performance.getEntriesByType('paint')[0].startTime);
          }
        }
        module.performanceStats = stats;
      }
      return module.performanceStats;
    };

    var _getProducts = function _getProducts() {
      if (!module.products) {
        var productsDomElements = Array.from(document.querySelectorAll('.thg-track[rel]'));
        module.products = productsDomElements.map(function (product) {
          return {
            Pid: product.getAttribute('rel')
          };
        });
      }
      return module.products;
    };

    var _getBasket = function _getBasket(args) {
      if (!module.basket) {
        var data = args[0];
        var basketItems = data.simpleBasket.basketItems;
        var basketItemsJson = basketItems.map(function (basketItem, index) {
          return {
            BasketItemId: index + 1,
            ProductId: !basketItem.productId ? basketItem.productId : 0,
            ChildMasterProductId: !basketItem.childMasterProductId ? basketItem.childMasterProductId : 0,
            FreeGift: basketItem.freeGift,
            Quantity: basketItem.quantity,
            Price: basketItem.price.split(';')[1]
          };
        });

        module.basket = {
          BasketId: data.simpleBasket.basketId,
          lastAddedItem: data.simpleBasket.lastAddedItem.productId,
          TotalPrice: data.simpleBasket.totalprice.split(';')[1],
          BasketItems: basketItemsJson,
          Event: 'basketItemAdded'
        };
      }
      return module.basket;
    };

    module.isTimingEnabled = !!$window.performance;
    module.timingAPI = {};
    if (module.isTimingEnabled && !!$window.performance.timing) {
      module.timingAPI = $window.performance.timing;
    }

    // Public API methods
    module.getExperiments = _getExperiments;
    module.getPerformanceStats = _getPerformanceStats;
    module.getMetaData = _getMetaData;
    module.getWidgetData = _getWidgetData;
    module.getProducts = _getProducts;
    module.getMetrics = _getMetrics;
    module.getBasket = _getBasket;
    module.getSiteObjItem = _getSiteObjItem;

    return module;
  };

  return Metrics;
});
//# sourceMappingURL=columbo-metrics.js.map
